import { styled as s, Box as T, Typography as w } from "@mui/material";
import ce from "../../../assets/icons/icon-user.svg.js";
import pe from "../../share/generic/IconText.js";
import de from "../../share/mui/Textfield.js";
import le from "../../share/next/NextLink.js";
import ue from "../../../config/index.js";
import { AdeptusInputMode as a, AdeptusCampaignType as Q } from "../../../constants/adeptus.js";
import { ERROR_CODE as me } from "../../../constants/error.js";
import { QUERY as N } from "../../../constants/query.js";
import { useAdeptusContext as fe } from "../../../contexts/adeptus/AdeptusContext.js";
import { CustomError as he } from "../../../errors/customError.js";
import Ie from "../../../hooks/graphql/useCheckInviter.js";
import ge from "../../../hooks/graphql/useGetAdeptusCampaigns.js";
import ve from "../../../hooks/graphql/useGetBelievedInviter.js";
import we from "../../../hooks/graphql/useGetPublicAccountDetail.js";
import Ce from "../../../hooks/graphql/useSendBelieveInviter.js";
import { isFullInviteCode as O } from "../../../util/adeptus/index.js";
import { noForwardProps as xe } from "../../../util/styled/index.js";
import { useRouter as ye } from "next/router";
import * as e from "ramda";
import { useMemo as Ee, useState as b, useCallback as h, useEffect as _ } from "react";
import { useTranslation as Ae, Trans as Ne } from "react-i18next";
import { jsx as o, Fragment as L, jsxs as k } from "react/jsx-runtime";
const Oe = s(T)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 5px;
`, be = s(T)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`, _e = s(w)`
  color: #838383;
  font-size: 14px;
  font-weight: 500;
  margin-left: 5px;
  white-space: nowrap;
`, ke = s(w)`
  color: white;
  font-size: 12px;
  font-weight: 300;
  margin-left: 5px;
  white-space: nowrap;
`, Te = s(le)`
  color: #ffb10b;
  display: inline;
`, Re = s(T)`
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: hidden;
  width: 100%;
`, Be = s(de, xe)`
  .MuiOutlinedInput-root {
    background-color: #0b0b0c;
    display: flex;
    height: 50px;
    justify-content: center;
    padding: 0px 20px;
    width: 100%;
  }
  .MuiOutlinedInput-input {
    background-color: unset;
    box-shadow: unset;
    color: white;
    max-width: calc(50% - 16px);
    padding: 0px;
    ${(r) => r.__alignRight ? "text-align: left;" : "text-align: center;"}
  }
  .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled {
    -webkit-text-fill-color: unset;
    color: white;
  }
`, Me = s(T)`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;
`, Se = s(w)`
  color: #ffaa03;
  font-size: 20px;
  font-weight: 500;
  margin: 10px;
`, Le = s(pe)`
  flex: 1;
  overflow: hidden;
  .Custom-Icon {
    filter: brightness(70%);
    min-width: 20px;
    width: 20px;
  }
  .Custom-Text {
    color: #c4c5c5;
    font-size: 14px;
    font-weight: 300;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`, Fe = s(w)`
  color: red;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`, Pe = s(w)`
  color: #c4c5c5;
  font-size: 14px;
  font-weight: 300;
  white-space: nowrap;
`, De = s(w)`
  color: #838383;
  font-size: 12px;
  font-weight: 300;
  margin-left: 5px;
`, Ve = (r) => e.isEmpty(e.propOr("", "walletAddress", r)), ze = (r) => e.isNil(r), F = (r) => !Ve(r) && !ze(r), pt = (r) => {
  const {
    className: J,
    inviterId: C = "",
    mode: d = a.AccountLogin,
    presetInviter: c,
    showFoot: K = !0,
    showHead: W = !0,
    type: R = Q.NoCampaign,
    walletAddress: I = ""
  } = r, X = ye(), x = e.propOr({}, "query", X), i = Ee(() => {
    switch (d) {
      case a.MintPopup:
        return {
          campaignId: e.propOr("", N.CAMPAIGN_ID, x),
          inviteCode: e.propOr("", N.INVITE_CODE, x),
          noInput: !1,
          show: O(x[N.INVITE_CODE])
        };
      case a.AccountLogin:
        return {
          campaignId: "",
          inviteCode: e.propOr("", N.INVITE_CODE, x),
          noInput: !1,
          show: !0
        };
      case a.AccountSetting:
        return {
          campaignId: "",
          inviteCode: "",
          noInput: !0,
          show: !e.isEmpty(C)
        };
      case a.SuccessPopup:
      default:
        return {
          campaignId: "",
          inviteCode: e.pathOr("", ["invitation", "code"], c),
          noInput: !0,
          show: !e.isNil(c)
        };
    }
  }, [C, d, c, x]), {
    t: g
  } = Ae(), {
    setInviter: P,
    inviter: y
  } = fe(), {
    fetch: D
  } = ge(), {
    fetch: V,
    loading: Z
  } = Ie(), {
    fetch: z,
    loading: ee
  } = ve(), {
    fetch: G,
    loading: te
  } = we(), {
    mutate: j
  } = Ce(), [l, ne] = b(c || null), [p, ie] = b(i.campaignId), [u, E] = b(i.inviteCode), [oe, B] = b(!1), U = Z || ee || te || !oe, v = h((n) => {
    ne(n), P(n);
  }, [P]), $ = h(async (n) => {
    const t = await V(n);
    return v(t), e.isNil(t) || !F(t) ? null : t;
  }, [V, v]), q = h(async (n, t) => {
    if (!await j({
      id: p,
      code: n,
      address: t
    }))
      throw new he("fail to believe inviter", me.ADEPTUS.CANNOT_BELIEVE_INVITER);
  }, [j, p]), m = h(async (n) => {
    try {
      if (O(n)) {
        const t = await $(n);
        B(!0), !e.isNil(t) && !e.isEmpty(I) && p !== "0" && await q(n, I);
      }
    } catch (t) {
      console.error(t);
    }
  }, [p, q, $, I]), se = h((n) => {
    const t = n.target.value;
    E(t), v(null), m(t);
  }, [m, v]), H = h(async () => {
    if (e.isEmpty(p) && R !== Q.NoCampaign) {
      const n = await D(), f = e.pipe(e.filter((A) => A.type === R), e.pathOr("0", ["0", "id"]))(n);
      return ie(f), f;
    }
  }, [p, D, R]), M = h(async (n) => {
    var A;
    let t = null;
    if (e.has("inviterId", n)) {
      const {
        inviterId: S
      } = n;
      t = await G({
        accountId: S
      });
    } else {
      const {
        campaignId: S,
        walletAddress: ae
      } = n;
      t = await z({
        id: S,
        address: ae
      });
    }
    B(!0), F(t) && v(t), O(i.inviteCode) && ((A = t == null ? void 0 : t.invitation) == null ? void 0 : A.code) !== i.inviteCode ? m(i.inviteCode) : E(e.pathOr("", ["invitation", "code"], t));
  }, [i.inviteCode, G, z, v, m]), re = h(() => !i.noInput && e.isEmpty(u) ? /* @__PURE__ */ o(L, {}) : U ? /* @__PURE__ */ o(Pe, {
    children: g("adeptus.input.loading")
  }) : F(l) ? /* @__PURE__ */ o(Le, {
    className: "Custom-Adeptus-Name",
    startSrc: ce,
    text: `${l == null ? void 0 : l.name} #${l == null ? void 0 : l.tag}`
  }) : /* @__PURE__ */ o(Fe, {
    children: g("adeptus.input.invalid_code")
  }), [u, i.noInput, l, U, g]);
  _(() => {
    E(i.inviteCode);
  }, [i.inviteCode]), _(() => {
    d === a.MintPopup && H();
  }, [d, H]), _(() => {
    switch (d) {
      case a.MintPopup:
        e.isNil(c) && !e.isEmpty(I) && !e.isEmpty(p) && M({
          campaignId: p,
          walletAddress: I
        });
        break;
      case a.AccountSetting:
        e.isNil(c) && !e.isEmpty(C) && M({
          inviterId: C
        });
        break;
      case a.SuccessPopup:
        B(!0);
        break;
    }
  }, [p, i.inviteCode, C, d, c, I, M, m, u]), _(() => {
    var n, t;
    if (d === a.AccountLogin) {
      if (e.isNil(c) && !y && O(i.inviteCode))
        E(i.inviteCode), m(i.inviteCode);
      else if (e.isNotNil(y) && ((n = y.invitation) == null ? void 0 : n.code) !== u) {
        const f = ((t = y.invitation) == null ? void 0 : t.code) || "";
        E(f), m(f);
      }
    }
  }, [u, i.inviteCode, m, d, c, y]);
  const Y = ue.URL.MISSIONARY;
  return i.show ? /* @__PURE__ */ k(Oe, {
    className: J,
    children: [W && /* @__PURE__ */ k(be, {
      children: [/* @__PURE__ */ o(_e, {
        className: "Custom-Adeptus-Label",
        children: g("adeptus.input.missionary")
      }), !e.isEmpty(Y) && /* @__PURE__ */ o(ke, {
        className: "Custom-Adeptus-Explain",
        children: /* @__PURE__ */ o(Ne, {
          components: {
            Link: /* @__PURE__ */ o(Te, {
              href: Y,
              target: "_blank"
            })
          },
          children: g("adeptus.input.what_is_missionary")
        })
      })]
    }), /* @__PURE__ */ k(Re, {
      className: "Custom-Adeptus-Text-Input-Container",
      children: [/* @__PURE__ */ o(Be, {
        __alignRight: !e.isEmpty(u),
        autoComplete: "off",
        className: "Custom-Adeptus-Text-Input",
        disabled: i.noInput,
        placeholder: "Enter your code",
        value: u,
        onChange: se,
        InputProps: {
          endAdornment: e.isEmpty(u) ? /* @__PURE__ */ o(L, {}) : /* @__PURE__ */ k(Me, {
            children: [/* @__PURE__ */ o(Se, {
              children: "/"
            }), re()]
          })
        }
      }), K && /* @__PURE__ */ o(De, {
        className: "Custom-Adeptus-Remark",
        children: g("adeptus.input.new_user_only")
      })]
    })]
  }) : /* @__PURE__ */ o(L, {});
};
export {
  pt as default
};
//# sourceMappingURL=AdeptusCodeInput.js.map
